module.exports = __webpack_public_path__ + "img/smile.016349b6.svg";